// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu[data-v-d15a6ab6] {\n  height: 100%;\n  padding-top: 27px;\n  position: relative;\n  z-index: 2;\n}\n", ""]);
// Exports
module.exports = exports;
